import React from "react";
import { ReactElement } from "react";
import * as DashboardStore from '../../store/DashboardStore';
import { connect } from 'react-redux';
import { LoggedInUser } from "../../models/LoggedInUser";
import { PolicyInfo } from "../../models/PolicyInfo";
import { AddressAutoCompleteForm } from "./AddressAutoCompleteForm";

interface CutoverAddressCollectionProps {
    loggedInUser: LoggedInUser;
    policy: PolicyInfo;
    eligibleProgram: any;
}

interface CutoverAddressCollectionState {
    policy: PolicyInfo,
    eligibleProgram: any,
    selectedOption: string
}


export class CutoverAddressCollection extends React.Component<any, CutoverAddressCollectionState> {
    constructor(props: CutoverAddressCollectionProps) {
        super(props);
        this.state = {
            policy: this.props.policy,
            eligibleProgram: this.props.eligibleProgram,
            selectedOption: ""
        };

    }

    async componentDidMount(): Promise<void> {
        (document.getElementById("address_1") as HTMLInputElement).value = this.props.policy?.addressLine1 || "";
        (document.getElementById("address_2") as HTMLInputElement).value = this.props.policy?.addressLine2 || "";
        (document.getElementById("postal_code") as HTMLInputElement).value = this.props.policy?.zipCode || "";
    }

    onClickNext(): void {
        const { enrollPolicyFromCutover, policy } = this.props;
        let cutoverAddressCollectionContainer = document.getElementById("cutover-address-collection-container") as HTMLElement;
        let cutoverSuccessContainer = document.getElementById("cutover-success-container") as HTMLElement;
        let address1 = (document.getElementById("address_1") as HTMLInputElement).value;
        let address2 = (document.getElementById("address_2") as HTMLInputElement).value;
        let postalCode = (document.getElementById("postal_code") as HTMLInputElement).value;
        let city = (document.getElementById("locality") as HTMLInputElement).value;
        let state = (document.getElementById("administrative_area_level_1") as HTMLInputElement).value;

        policy.addressLine1 = address1;
        policy.addressLine2 = address2;
        policy.zipCode = postalCode;
        policy.city = city === "" || city === null ? policy.city : city;
        policy.state = state === "" || state === null ? policy.state : state;

        enrollPolicyFromCutover(policy);
        cutoverAddressCollectionContainer.style.display = "none";
        cutoverSuccessContainer.style.display = "block";
    }

    onClickBack(): void {
        let cutoverAddressCollectionContainer = document.getElementById("cutover-address-collection-container") as HTMLElement;
        let cutoverContainer = document.getElementById("cutover-container") as HTMLElement;

        cutoverContainer.style.display = "block";
        cutoverAddressCollectionContainer.style.display = "none";
    }

    render(): ReactElement {
        return (
            <>
                <div className="container cutover-container" id="cutover-address-collection-container" style={{display: "none"}}>
                    <div className="row cutover-header-row">
                        <div className="col-sm-12">
                            <div className="cutover-address-collection-header">Where should we send your DriveEasy Pro device(s)?</div>
                        </div>
                        <div className="col-sm-12">
                            <div className="cutover-address-collection-subheader">You’ll receive your DriveEasy Pro OBD (On-Board Diagnostic) device(s) in the mail. Plug the device(s) into the OBD port inside your vehicle(s) to access real-time vehicle location on the DriveEasy Pro Dashboard.</div>
                        </div>
                        <div className="col-sm-12">
                            <AddressAutoCompleteForm />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-8">
                        </div>
                        <div className="col-sm-2">
                            <button id="cutover-address-collection-button-back" className="cutover-address-collection-button-back" onClick={() => this.onClickBack()}>Back</button>
                        </div>
                        <div className="col-sm-2">
                            <button id="cutover-address-collection-button-agree" className="cutover-address-collection-button-agree" onClick={() => this.onClickNext()}>Next</button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => ({
    loggedInUser: state.loggedInUser,
    policy: state.dshs.policy,
    eligibleProgram: state.dshs.eligibleProgram,
});

export default connect(
    mapStateToProps,
    DashboardStore.actionCreators,
)(CutoverAddressCollection as any);